import { useEffect, useState } from "react";
import api, { fmtErr } from "@/lib/api";
import { toast } from "sonner";
import { PageHeader, Loading } from "@/components/bits";
import { Activity } from "lucide-react";

const COLORS = {
  CREATE: "text-emerald-400 border-emerald-500/30 bg-emerald-500/10",
  UPDATE: "text-sky-400 border-sky-500/30 bg-sky-500/10",
  DELETE: "text-rose-400 border-rose-500/30 bg-rose-500/10",
  QC: "text-amber-400 border-amber-500/30 bg-amber-500/10",
  DELIVERY: "text-indigo-400 border-indigo-500/30 bg-indigo-500/10",
};

export default function Audit() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/audit?limit=60").then((r) => setRows(r.data)).catch((e) => toast.error(fmtErr(e))); }, []);

  return (
    <div className="space-y-5">
      <PageHeader id="Audit Log & Revisi" zh="审计日志与修改历史" desc="Jejak lengkap semua perubahan data sistem." />
      <div className="panel p-5" data-testid="audit-panel">
        {!rows ? <Loading /> : rows.length === 0 ? (
          <div className="py-16 text-center text-sm text-slate-500">Belum ada aktivitas / 暂无活动</div>
        ) : (
          <div className="relative space-y-0 pl-6" data-testid="audit-timeline">
            <div className="absolute bottom-2 left-[7px] top-2 w-px bg-slate-800" />
            {rows.map((r) => (
              <div key={r.id} className="relative py-3" data-testid="audit-item">
                <span className={`absolute -left-6 top-3.5 flex h-4 w-4 items-center justify-center rounded-full border ${COLORS[r.action] || COLORS.UPDATE}`}>
                  <Activity className="h-2.5 w-2.5" />
                </span>
                <div className="flex flex-wrap items-baseline gap-2">
                  <span className={`rounded border px-1.5 py-0.5 font-mono text-[10px] ${COLORS[r.action] || COLORS.UPDATE}`}>{r.action}</span>
                  <span className="text-sm font-medium text-slate-200">{r.name}</span>
                  <span className="text-xs text-slate-500">{r.entity}</span>
                </div>
                <div className="mt-0.5 text-xs text-slate-500">{r.detail}</div>
                <div className="mt-0.5 font-mono text-[10px] text-slate-600">{r.by} · {new Date(r.at).toLocaleString("id-ID")}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}